import {
  type CreateUserProps,
  type CreateUserResponseProps,
  type UserType,
} from '@/services/types/mockUser'
import { api, v2BaseURL } from './api'
import { endpoints } from './endpoints'

export interface UsersProps {
  users: UserType[]
}

interface CreateUserResponse {
  user: CreateUserResponseProps
}

type ServiceUserAttributes = {
  name: string
  sub?: string
  email?: string
  givenName?: string
  familyName?: string
  emailVerified?: string
  updatedAt?: string
  'custom:tenantId'?: string
  'custom:optInMarketing'?: string
}

export const usersService = {
  async getAllUsersInAccount() {
    return api.get<UsersProps>(endpoints.users, {
      baseURL: v2BaseURL,
    })
  },

  async createUser(data: CreateUserProps) {
    return api.post<CreateUserResponse>(endpoints.users, data, {
      baseURL: v2BaseURL,
    })
  },

  async disableUser(email: string) {
    const data = {
      email,
      enabled: false,
    }

    return api.post<void>(`${endpoints.users}/login-ability`, data, {
      baseURL: v2BaseURL,
    })
  },

  async resendConfirmationEmail(email: string) {
    const data = {
      email,
    }

    return api.post<void>(`${endpoints.users}/reset`, data, {
      baseURL: v2BaseURL,
    })
  },

  async updateUserAttributes(userAttributes: Partial<ServiceUserAttributes>) {
    return api.patch<void>(endpoints.users, userAttributes, {
      baseURL: v2BaseURL,
    })
  },
}
